import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ProcedureTypeActions from './procedure-types.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ProcedureTypeStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ProcedureTypeActions.ProcedureTypeRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.ALLABSIS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ProcedureTypeActions.ProcedureTypeCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ProcedureTypeActions.ProcedureTypeUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ProcedureTypeActions.ProcedureTypeDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ProcedureTypeActions.ProcedureTypeRefresh());
      }
    });

  }
}
